import React from 'react';
import styles from './styles/FiltersSidebar.module.scss';
import { SkeletonFacet } from './Skeleton.facet';
export const SkeletonFilterSidebar = () => (React.createElement("div", { className: `ov:h ${styles.sidebarWrapper}` }, [...Array(4)].map((v, i) => React.createElement(SkeletonFacet, { key: i }))));
